module.exports = __webpack_public_path__ + "img/teacher_desc.299ae4a7.png";